import React, {
  DetailedHTMLProps,
  FieldsetHTMLAttributes,
  forwardRef,
} from 'react';
import classnames from 'classnames';

import styles from './index.module.css';

export type SectionFieldsetProps = DetailedHTMLProps<
  FieldsetHTMLAttributes<HTMLFieldSetElement>,
  HTMLFieldSetElement
> & {
  legend: string;
  required?: boolean;
};

export const SectionFieldset = forwardRef<
  HTMLFieldSetElement,
  SectionFieldsetProps
>(({ legend, required, children, ...props }, ref) => {
  return (
    <fieldset
      {...props}
      ref={ref}
      className={classnames(
        'box-border',
        'm-0',
        'p-0',
        'border-none',
        styles['root'],
      )}
    >
      <legend
        className={classnames(
          'rs-font',
          'block',
          'mb-2',
          'text-24',
          'pc:text-20',
          'text-gray-1000',
          'font-bold',
          'before:block',
          'before:text-[13px]',
          'before:font-normal',
          'before:leading-none',
          'pc:before:text-[12px]',
          styles['legend'],
        )}
      >
        {legend}
        {required && (
          <span className="text-16 pc:text-15 font-normal text-red-700">
            （必須）
          </span>
        )}
      </legend>
      <div>{children}</div>
    </fieldset>
  );
});

SectionFieldset.displayName = 'SectionFieldset';
